import React, { useEffect } from 'react';
import { Event } from '../../../../../../app/models/Event';
import useHandleErrorFields from "../../../../../../hooks/useHandleErrorFields";

type Props = {
    EventDataForm: Event;
    setEventDataForm: (Event: Event) => void;
    errorFields?: any;
};

const EventFormCreate = ({ EventDataForm, setEventDataForm, errorFields }: Props) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (
        e:
            | React.ChangeEvent<HTMLInputElement>
            | React.ChangeEvent<HTMLSelectElement>
            | React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        const { name, value } = e.target;
        setEventDataForm({ ...EventDataForm, [name]: value });
    };

    return (
        <>
            <div className="mb-2 row needs-validation">
                <div className="col-md-12">
                    <label className="col-form-label">Titulo</label>

                    <input
                        name="title"
                        id="title"
                        type="text"
                        className={`form-control ${fieldHasError('name')}`}
                        value={EventDataForm.title}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('title')}
                        placeholder="Ingrese el nombre de Evento"
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('title')}
                    </div>
                </div>

                <div className="col-md-12">
                    <label className="col-form-label">Tipo de evento</label>
                    <select
                        className={`form-control ${fieldHasError('event_type')}`}
                        name="event_type"
                        id="event_type"
                        value={EventDataForm.event_type}
                        onChange={handleChange}
                    >
                        <option>Presencial</option>
                        <option>Remoto</option>
                        <option>Stand</option>
                    </select>
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('event_type')}
                    </div>
                </div>

                <div className="col-md-12">
                    <label className="col-form-label">Fecha Inicio</label>
                    <input
                        name="start_date"
                        id="start_date"
                        type="date"
                        className={`form-control ${fieldHasError('start_date')}`}
                        value={EventDataForm?.start_date}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('start_date')}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('start_date')}
                    </div>
                </div>

                <div className="col-md-12">
                    <label className="col-form-label">Fecha Termino</label>
                    <input
                        name="end_date"
                        id="end_date"
                        type="date"
                        className={`form-control ${fieldHasError('end_date')}`}
                        value={EventDataForm?.end_date}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('end_date')}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('end_date')}
                    </div>
                </div>
            </div>
        </>
    );
};

export default EventFormCreate;
